import { cn } from "@/utils"
import { DepositStatus, DepositType, parseDepositStatus, useStatus } from "@usher/pe-client-front-end-lib"
import { FormattedMessage } from "react-intl"
import { Fragment } from "react/jsx-runtime"
import { Charged } from "./LeftSections/Charged"
import { Error } from "./LeftSections/Error"
import { Fullfilled } from "./LeftSections/Fullfilled"
import { Pending } from "./LeftSections/Pending"
import { ProgressBar } from "./LeftSections/Progressbar"
import { Receive } from "./LeftSections/Received"
import { Waiting } from "./LeftSections/Waiting"
import { RightSection } from "./RightSection"
import "./style.sass"

const getDepositStatus = (status: string, confirmation: number, msg?: string, isOrder: boolean = false) => {
  const st = parseDepositStatus(status)
  switch (st) {
    case DepositStatus.Completed:
      return <Fullfilled title={status} />
    case DepositStatus.Charged:
      return <Charged title={status} />
    case DepositStatus.Error:
      return <Error title={status} msg={msg ?? "Exchange is not completed"} />
    case DepositStatus.Pending:
      return <Pending title={status} confirmation={confirmation} isOrder={isOrder} />
    case DepositStatus.FullFilled:
      return <Fullfilled title={status} />
    case DepositStatus.Received:
      return <Receive title={status} confirmation={confirmation} />
    case DepositStatus.Waiting:
      return <Waiting title={status} confirmation={confirmation} />
    default:
      return (
        <h1 className="text-center !text-gray-400">
          <FormattedMessage id="loading" />
        </h1>
      )
  }
}
const IS_ENDING_STATUSES = [DepositStatus.Charged, DepositStatus.Error]
const Status = ({ depositType, isOrder }: { depositType?: DepositType; isOrder?: boolean }) => {
  const { status, loading, confirmation, fetchStatus, error } = useStatus({ depositType })
  const isEnding = IS_ENDING_STATUSES.includes(parseDepositStatus(status ?? ""))
  return (
    <Fragment>
      {depositType === DepositType.IBAN && isOrder && (
        <div className={cn("p-4", "bg-white mb-4 border")}>
          <div className="container max-w-[500px] flex flex-col items-center center">
            <span className="main-form-cards_title mb-0">Open Bank Account</span>
          </div>
        </div>
      )}
      <div className="top-status">
        <div className="top-status__left border">
          {!isEnding && status != null && <ProgressBar onUpdate={fetchStatus} />}
          {loading ? (
            <h1 className="text-center !text-gray-400">
              <FormattedMessage id="loading" />
            </h1>
          ) : (
            getDepositStatus(status?.replace(/\bexchange\b/i, ""), confirmation, error, isOrder)
          )}
        </div>
        <div className="top-status__right border">
          <RightSection depositType={depositType} isOrder={isOrder} />
        </div>
      </div>
    </Fragment>
  )
}

export default Status
